/*jshint esversion: 6 */
require('./css.js');

let settings = require("./config.json");
let App = require('./js/main.js');

let web = new App(settings, (context) => {
	web.modal.bindAll(context);
	web.custom.bindAll(context);
});

$(document).ready(() => {
	let CustomModule = require('./js/custom.js');
	web.custom = new CustomModule(web);

	// Modal
	if(web.settings.modal){
		let WebModal = require('./js/modules/modal.js');
		web.modal = new WebModal(web, web.settings.modal);
	}

	web.bindAll();
});

window.web = web;



// WEBPACK FOOTER //
// ./C:/wamp64/www/cig-landing/devel/app.js